import { render } from "./prefixes.vue?vue&type=template&id=0bbf34c3"
import script from "./prefixes.vue?vue&type=script&lang=js"
export * from "./prefixes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__